import Vue from "vue";
import Router from "vue-router";
import Home from "./page/Home.vue";
import Trademark from "./page/Trademark.vue";
import Patent from "./page/Patent.vue";
import Copyright from "./page/Copyright.vue";
import Special from "./page/Special.vue";
import Policy from "./page/Policy.vue";
import Case from "./page/Case.vue";
import TradeDetail from "./page/TradeDetail.vue"
import PatentDetail from './page/PatentDetail.vue'
import CopyrightDetail from './page/CopyrightDetail.vue'
import PolicyDetail from './page/PolicyDetail.vue'
import CaseDetail from './page/CaseDetail.vue'
import Evaluation from './page/Evaluation.vue'
Vue.use(Router);

export default new Router({
	base: "lanzhou_technology_market_portal",
	routes: [

		/************************************* 首页 开始 ↓ *************************************/
		{
			path: "",
			name: "patent",
			component: Patent
		},
		{
			path: "/",
			name: "patent",
			component: Patent
		},
		{
			path: "/home",
			name: "home",
			component: Home
		},
		/* 商标商城 */
		{
			path: '/Trademark',
			name: 'trademark',
			component: Trademark
		},
		/* 商标商城详情 */
		{
			path: "/Trademark/:id",
			name: "trademark",
			component: TradeDetail
		},
		/* 专利商城 */
		{
			path: '/Patent',
			name: 'patent',
			component: Patent
		},
		/* 专利商城详情 */
		{
			path: "/Patent/:id",
			name: "patent",
			component: PatentDetail
		},
		/* 版权商城 */
		{
			path: '/Copyright',
			name: 'copyright',
			component: Copyright
		},
		/* 版权商城详情 */
		{
			path: "/Copyright/:id",
			name: "copyright",
			component: CopyrightDetail
		},
		/* 特价商城 */
		{
			path: '/Special',
			name: 'special',
			component: Special
		},
		/* 政策解读 */
		{
			path: '/Policy',
			name: 'policy',
			component: Policy
		},
		/* 政策解读详情 */
		{
			path: "/Policy/:id",
			name: "policy",
			component: PolicyDetail
		},
		/* 成功案例 */
		{
			path: '/Case',
			name: 'case',
			component: Case
		},
        /* 成功案例详情 */
        {
        	path: '/Case/:id',
        	name: 'case',
        	component: CaseDetail
        },
		/*双软评估  */
		{
			path: '/Evaluation/',
			name: 'Evaluation',
			component: Evaluation
		},
         		
	]



});
